export enum SaferpayStatus {
  PENDING = "PENDING",
  PAID = "CAPTURED",
}
